import IntegrationTaskModelBase from '../_generated/modelBases/integration-task-model-base';

export default class IntegrationTaskModel extends IntegrationTaskModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
